"use client"

import dynamic from "next/dynamic"
import { ReactNode } from "react"
import ErrorBoundary from "./ErrorBoundary"

const PostHogInit = dynamic(() => import('./PostHogInit'), { ssr: false })

export function PostHogProvider({ children }: { children: ReactNode }) {
  return (
    <>
      {/* A failed analytics init must never take down the page (React #306 from a stale lazy chunk lands in global-error otherwise) */}
      <ErrorBoundary fallback={null} reportContext="client.widget.posthog">
        <PostHogInit />
      </ErrorBoundary>
      {children}
    </>
  )
}
